import { useTranslation } from "react-i18next";
import TypeaheadInput from "../../common/components/TypeaheadInput"
import useClientConfig from "../../common/hooks/clientConfigHook";
import { useEpcrComplaints } from "../../reducers/epcrComplaintSlice"
import ProblemInput from "../ProblemInput";
import { useMemo } from "react";

const EpcrComplaintInputImpl = ({ id, value, placeholder, disabled, required, onChange, hideLabel, readonly, wildcard, live }) => {
    const { t } = useTranslation();
    const complaints = useEpcrComplaints();

    const options = useMemo(() => complaints.map(c => c.complaint), [complaints])

    return <TypeaheadInput 
        id={id ?? "epcrComplaintInput"} 
        live={live} 
        options={options} 
        value={value} 
        placeholder={placeholder ?? t('complaint')}
        wildcard={wildcard}
        disabled={disabled}
        required={required}
        readonly={readonly}
        lockdown
        onChange={onChange}
        hideLabel={hideLabel}></TypeaheadInput>
}

const EpcrComplaintInput = ({ id, site, type, level, priority, value, placeholder, disabled, required, onChange, hideLabel, readonly, wildcard, live }) => {
    const clientConfig = useClientConfig();

    const handleProblemChange = update => {
        return onChange(update.problem);
    }
    
    if (clientConfig.useEpcrComplaints) {
        return <EpcrComplaintInputImpl 
            id={id} 
            value={value} 
            placeholder={placeholder} 
            disabled={disabled}
            required={required}
            onChange={onChange}
            hideLabel={hideLabel}
            readonly={readonly}
            wildcard={wildcard}
            live={live}></EpcrComplaintInputImpl>
    } else {
        return <ProblemInput
            id={id} 
            site={site}
            type={type}
            level={level}
            priority={priority}
            problem={value} 
            placeholder={placeholder} 
            disabled={disabled}
            required={required}
            onChange={handleProblemChange}
            hideLabel={hideLabel}
            readonly={readonly}
            wildcard={wildcard}
            live={live}></ProblemInput>
    }
};

export default EpcrComplaintInput;